import React from 'react'

import { TalkContent } from '@models/Article'

import * as style from './style.module.sass'

const Talk: React.FC<TalkContent> = ({ name, contents, color }) => (
  <div className={style.talk}>
    <span className={style.name} data-color={color[0]}>
      {name}
    </span>
    <span
      className={style.contents}
      dangerouslySetInnerHTML={{ __html: contents }}
    />
  </div>
)

export default Talk
